/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import SkeletonStyles from './SkeletonStyles';

const useStyles = makeStyles({
    ...SkeletonStyles,
    // Page Elements
    root: {
        width: '100%',
    },
    productInfo: {
        '&--blockHeader': {
            width: '70px',
            height: '8px',
            margin: '10px 0',
        },
    },
});
const QuickViewLinkSkeleton = () => {
    const classes = useStyles();
    return (
        <div className={`${classes.productInfo}--blockHeader ${classes.block}`} />
    );
};

export default QuickViewLinkSkeleton;
